<template>
    <v-system-bar window color="primary" dark>
    </v-system-bar>
</template>

<script>
    export default {
        name: "VierGewinntStatusBar",
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
 .v-system-bar {
     height: 1px !important;
 }
</style>
